class APIClient {
  constructor(baseURL) {
    this.baseURL = baseURL || process.env.REACT_APP_API_URL || '';
  }

  fetchPublic = (method, url, data = {}) => {
    let options = {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
    };
    if (Object.keys(data).length > 0) {
      options.body = JSON.stringify(data);
    }
    return fetch(`${this.baseURL}${url}`, options).then((response) => {
      return response
        .text()
        .then((text) => {
          const data = text !== '' ? JSON.parse(text) : [];
          const status = response?.status;
          return { data, status };
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    });
  };

  fetchAuth = (method, url, data = {}) => {
    const token = localStorage.getItem('op_token');
    let options = {
      method,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    if (Object.keys(data).length > 0) {
      options.body = JSON.stringify(data);
    }
    return fetch(`${this.baseURL}${url}`, options).then((response) => {
      if (response.status === 401) {
        localStorage.removeItem('op_token');
        window.location.href = `/${process.env.PUBLIC_URL}/operator/login`;
        throw new Error('Session expired');
      }
      return response
        .text()
        .then((text) => {
          const data = text !== '' ? JSON.parse(text) : [];
          const status = response?.status;
          return { data, status };
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    });
  };

  fetchAuthBlob = (url) => {
    const token = localStorage.getItem('op_token');
    return fetch(`${this.baseURL}${url}`, {
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => {
      if (response.status === 401) {
        localStorage.removeItem('op_token');
        window.location.href = `/${process.env.PUBLIC_URL}/operator/login`;
        throw new Error('Session expired');
      }
      return response.blob();
    });
  };

  post = (url, data) => {
    return this.fetchPublic('POST', `${url}`, data);
  };

  put = (url, data) => {
    return this.fetchPublic('PUT', `${url}`, data);
  };

  get = (url) => {
    return this.fetchPublic('GET', `${url}`);
  };

  authPost = (url, data) => {
    return this.fetchAuth('POST', `${url}`, data);
  };

  authGet = (url) => {
    return this.fetchAuth('GET', `${url}`);
  };

  authBlob = (url) => {
    return this.fetchAuthBlob(`${url}`);
  };
}

export { APIClient };
